<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("love.menu.reviews_list") }} </template>
        <template #sidebarCta>
            <ButtonSecondarySm @click="$emit('add')">
                <AddIcon />
                <span>{{ $t("love.reviews_list.new") }}</span>
            </ButtonSecondarySm>
        </template>
        <template #sidebarMain>
            <div class="p-6 space-y-5">
                <NotificationAlert
                    v-if="newTestimonials.length"
                    :title="$t('love.reviews.unpublished_title')"
                    :subtitle="$t('love.reviews.accept_info')"
                    :closeButton="false"
                    :ctaLabel="$t('love.reviews.accept_cta')"
                    :ctaCallback="acceptAllTestimonials"
                />

                <draggable
                    v-model="testimonialList"
                    item-key="id"
                    @start="drag = true"
                    @end="drag = false"
                    @change="order"
                >
                    <template #item="{ element }">
                        <div class="relative mt-2 group" v-if="!element._deleted">
                            <ReviewCard
                                class="mb-3 ct-drag-item"
                                :testimonial="element"
                                @edit="edit(element)"
                                @confirm="confirm(element)"
                                @click="edit(element)"
                                @generate-image="image(element)"
                                @ask-for-confirmation="handleAskForConfirmation(element)"
                            />
                            <div
                                class="absolute top-1/2 -left-3 -translate-y-1/2 ct-fg-4 opacity-0 group-hover:opacity-100 cursor-move pr-2 h-full flex items-center"
                            >
                                <DragDropIcon />
                            </div>
                        </div>
                    </template>
                </draggable>

                <CardEmpty
                    class="w-full"
                    v-if="!testimonialList.length"
                    :title="$t('love.empty.title')"
                    :icon="emptyIcon"
                    :ctaLabel="$t('love.empty.cta')"
                    @add="$emit('add')"
                />
            </div>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { markRaw } from "vue";
import draggable from "vuedraggable";
import { mapState, mapMutations, mapActions } from "vuex";
import { PageSidebar } from "@easy/ui/page-components";
import { ButtonSecondarySm } from "@easy/ui/buttons";
import { AddIcon, DragDropIcon, LoveIcon } from "@easy/ui/icons";
import { CardEmpty } from "@easy/ui/cards";
import { NotificationAlert } from "@easy/ui/notifications";
import ReviewCard from "./ReviewCard.vue";
import cSaveButton from "@/shared/components/cSaveButton.vue";

export default {
    components: {
        draggable,
        PageSidebar,
        AddIcon,
        ReviewCard,
        ButtonSecondarySm,
        DragDropIcon,
        CardEmpty,
        NotificationAlert,
        cSaveButton,
    },
    emits: ["edit", "add", "confirm"],
    computed: {
        ...mapState("love", ["wall", "testimonials", "hasChanges"]),
        testimonialList: {
            get() {
                return this.testimonials;
            },
            set(value) {
                this.setTestimonials(value);
            },
        },
        emptyIcon() {
            return markRaw(LoveIcon);
        },
        newTestimonials() {
            return this.testimonials.filter((testimonial) => !testimonial.isPublished);
        },
    },
    methods: {
        ...mapMutations("love", ["setTestimonials", "addTestimonial", "acceptAllTestimonials"]),
        ...mapActions("love/projects", ["saveSnapshot"]),
        ...mapActions("love/uploads", ["generateImage2"]),
        edit(testimonial) {
            this.$emit("edit", testimonial);
        },
        handleAskForConfirmation(testimonial) {
            this.$emit("confirm", testimonial);
        },
        order() {
            this.setTestimonials();
        },
        image(testimonial) {
            this.generateImage2(testimonial);
        },
    },
};
</script>
